import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  OnDestroy,
  input,
  signal
} from '@angular/core';
import {MatSidenavModule} from '@angular/material/sidenav';
import {RouterOutlet} from '@angular/router';
import {retrieveProject} from '../../service/project.actions';
import {Store} from '@ngrx/store';
import {ProjectSideNavComponent} from '../project-side-nav/project-side-nav.component';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';
import {ClickEventService} from '../../../../utils/services/click-event.service';
import {NgClass} from '@angular/common';
import {TourService} from 'ngx-ui-tour-md-menu';
import {slideInAnimation} from '../../../research/animation/route-animations';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-project-detail-wrapper',
  imports: [MatSidenavModule, RouterOutlet, ProjectSideNavComponent, NgClass],
  templateUrl: './project-detail-wrapper.component.html',
  styleUrl: './project-detail-wrapper.component.scss',
  animations: [slideInAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectDetailWrapperComponent implements OnDestroy, AfterViewInit {
  private readonly store: Store = inject(Store);
  private readonly tourService = inject(TourService);

  private readonly clickEventService: ClickEventService = inject(ClickEventService);
  private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
  readonly projectId = input<number>();

  readonly isSmallScreen = toSignal(
    this.breakpointObserver.observe([Breakpoints.Handset]).pipe(map(result => result.matches)),
    {initialValue: false}
  );
  readonly isOpen = signal(true);
  private clickEventSubscription?: Subscription;

  prepareRoute(outlet: RouterOutlet) {
    const animation = outlet?.activatedRouteData?.['animation'];
    return animation || 'OverviewPage';
  }

  constructor() {
    effect(() => {
      const projectId = this.projectId();
      if (projectId) {
        this.store.dispatch(retrieveProject({id: projectId}));
      }
    });

    effect(() => {
      this.isOpen.set(!this.isSmallScreen());
    });

    this.clickEventSubscription = this.clickEventService.clickSideNavEvent$.subscribe(() => {
      this.isOpen.update(isOpen => !isOpen);
    });

    this.clickEventService.trackSubscription(this.clickEventSubscription);
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
  }

}
